// Stale-bundle detection (2026-09-23).
//
// index.html is served with max-age=0, so a normal navigation always
// gets the newest build. But a tab restored by the browser, or one left
// open across a deploy, boots the OLD hashed bundle and stays on it
// until someone hard-refreshes — the founder kept "not seeing" shipped
// features for exactly this reason. This compares the main asset hashes
// the page booted with against the ones production is serving now.

const ASSET_RE = /\/static\/(?:js|css)\/main\.[0-9a-f]+\.(?:js|css)/g;
const RELOADED_KEY = 'tc_reloaded_for_build';

export function assetIdsFromHtml(html) {
  const found = String(html || '').match(ASSET_RE) || [];
  return Array.from(new Set(found)).sort();
}

export function runningAssetIds(doc = document) {
  const ids = [];
  doc.querySelectorAll('script[src], link[rel="stylesheet"][href]').forEach((node) => {
    const url = node.getAttribute('src') || node.getAttribute('href') || '';
    ids.push(...(url.match(ASSET_RE) || []));
  });
  return Array.from(new Set(ids)).sort();
}

// Both sides must be known: in dev CRA serves bundle.js (no hashes) and
// a failed fetch yields nothing — neither is evidence of a newer build.
export function isNewerBuild(running, live) {
  if (!running.length || !live.length) return false;
  return running.join('|') !== live.join('|');
}

export async function fetchLiveAssetIds(fetchImpl = fetch) {
  const res = await fetchImpl(`/index.html?fresh=${Date.now()}`, {
    cache: 'no-store',
    credentials: 'omit',
  });
  if (!res.ok) return [];
  return assetIdsFromHtml(await res.text());
}

export async function checkForNewerBuild({ fetchImpl, doc } = {}) {
  const running = runningAssetIds(doc);
  const live = await fetchLiveAssetIds(fetchImpl);
  return { stale: isNewerBuild(running, live), liveKey: live.join('|') };
}

// Reload at most once per live build. If the page is somehow still
// stale after that reload (edge cache lag), the caller falls back to a
// prompt instead of looping.
export function reloadOnceFor(liveKey, reload = () => window.location.reload(), storage = window.sessionStorage) {
  let already = null;
  try { already = storage.getItem(RELOADED_KEY); } catch (_) { /* storage blocked */ }
  if (already === liveKey) return false;
  try { storage.setItem(RELOADED_KEY, liveKey); } catch (_) { /* storage blocked */ }
  reload();
  return true;
}
